<!--赖传峰-->
<!--2022/5/5-->
<template>
  <div class="error">
    <div class="not-found">
      <div class="not-found_logo" />
      <div class="tip">
        {{ $t('not-found-page-tip') }}
      </div>
    </div>
    <div
      v-if="isDev"
      class="debug"
    >
      <div
        v-for="(val, key) in error"
        :key="key"
      >
        <div
          v-if="String(key) !== 'description' && val"
          class="line"
        >
          <div class="key">{{ key }}:</div>
          <div class="value">
            {{ val }}
          </div>
        </div>
      </div>
      <code v-html="error?.message" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useError } from '#imports'

const error = useError()

const isDev = process.dev
</script>

<style lang="less" scoped>
.not-found {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.not-found_logo {
  width: 460px;
  height: 406px;
  background: url('./assets/images/404.svg') var(--no-repeat-center) / 100%;
}

.tip {
  color: #666;
}

.debug {
  border: var(--color-tertiary-text) 1px solid;
  padding: 20px;
  margin: 20px;

  .line {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
  }

  .value {
    margin-left: 9px;
  }
}

@media screen and (max-width: 460px) {
  .not-found_logo {
    width: 100%;
  }
}
</style>
